<template>
  <div class="order" :style="bannerFlag ? 'margin-top: 56px;' : ''">
    <div class="order-box w" style="min-height: calc(100vh - 125px);">
      <!-- 步骤标题 -->
      <div class="order-step">
        <div class="order-step-wrap" v-for="(item, i) in stepList" :key="i"
          :class="item.stepList.includes(currentStep+'') ? 'step-active' : ''">
          <i :class="item.icon" style="font-size: 18px;"></i>
          <span>{{ item.name }}</span>
        </div>
      </div>
      <div v-loading="loading" element-loading-text="加载中..." element-loading-background="rgba(0, 0, 0, 0)"
        style="min-height: calc(100vh - 220px);">
        <!-- 选中显示标题 -->
        <div class="order-title">
          {{ form.demName }} {{ catalogTitle }} <span v-if="currentStep != 1 && form.demPatient">【{{ form.demPatient}}】</span>
        </div>
        <!-- 步骤二 -->
        <div class="order-detail-design" style="min-height: calc(100vh - 313px);" v-if="this.currentStep === 2">
          <!-- 基本信息 -->
          <div class="order-basic-wrap">
            <base-tag label="基本信息" style="position: relative;"></base-tag>
            <!-- 联系人姓名 -->
            <div class="input-orthodontics el-input-contact spacing-height" style="margin-left: 3px;">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>下单名称</span>
              </div>
              <el-input class="input-form" v-if="user.demServType != '00'"
                :style="{ '--inputColorContact': colorContact }" v-model="form.demContact" size="mini"
                @input="change1" />
              <el-input class="input-form" v-else :style="{ '--inputColorContact': colorContact }"
                v-model="form.demContact" size="mini" @input="change1" :readonly="true" />
            </div>
            <!-- 联系方式 -->
            <div class="input-orthodontics el-input-contact spacing-height">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>联系方式</span>
              </div>
              <el-input class="input-form" :style="{ '--inputColorPhone': colorPhone }" v-model="form.demPhone"
                size="mini" @input="change2" />
            </div>
            <!-- 患者姓名 -->
            <div class="input-orthodontics el-input-contact spacing-height">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>患者姓名</span>
              </div>
              <el-input class="input-form" :style="{ '--inputColorPatient': colorPatient }" v-model="form.demPatient"
                size="mini" @input="change3" autocomplete="off" />
            </div>
            <!-- 患者性别 -->
            <div class="input-orthodontics el-input-contact spacing-height">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>患者性别</span>
              </div>
              <el-select class="input-form" v-model="form.demSex" filterable placeholder="请选择性别" size="mini">
                <el-option class="option-item" label="男" value="00"></el-option>
                <el-option class="option-item" label="女" value="99"></el-option>
              </el-select>
            </div>
            <!-- 患者年龄 -->
            <div ref="age" class="input-age el-input-contact spacing-height">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>年龄</span>
              </div>
              <el-select class="input-form" v-model="form.patientAge" filterable placeholder="请选择患者年龄" size="mini">
                <el-option v-for="val in 100" :label="val" :value="val" :key="val"></el-option>
              </el-select>
            </div>
          </div>
          <div class="order-input-wrap" v-if="subCatalogId == '3010130' && currentStep === 2">
            <base-tag class="makeCondition" label="矫治需求"></base-tag>
            <div class="case-class">
              <div class="case-class-box" style="margin-left: 1.3%;line-height: 50px;font-size: 15px;width: 50%;">
                <p class="case-class-item" style="float:left;">
                  <span>矫治牙列</span>
                  <el-checkbox-group v-model="form.countCalList" class="molar-item-check"
                    @change="changeMolar(form.countCalList)" style="line-height: 50px;width: 430px;">
                    <el-checkbox style="margin-right: 13.5%;" label="00">上颌5-5</el-checkbox>
                    <el-checkbox style="margin-right: 13.5%;" label="01">下颌5-5</el-checkbox>
                    <el-checkbox style="margin-right: 13.5%;" label="02">上下颌5-5</el-checkbox>
                  </el-checkbox-group>
                </p>
              </div>
              <div ref="rush" class="el-select-input spacing-height input-fac-rush" style="margin-left: -20px">
                <div class="input-label">
                  <span style="color:red">*</span>
                  <span>是否加急(元)</span>
                </div>
                <el-input-number v-model="form.orderRushFee" controls-position="right" @input="calAmount" :min="0"
                  :size="'small'" style="margin-left:13px;width:130px;"
                  :disabled="isEditServOrder == '1' ? true : false"></el-input-number>
              </div>
              <div ref="totalPrice" class="spacing-height input-fac-cal-two" style="margin-left: 105px;">
                <div class="input-label">
                  <span style="color:red">*</span>
                  <span>总价</span>
                </div>
                <el-input class="input-form" :style="{ '--inputColorOrderAmount': colorOrderAmount }"
                  v-model="form.orderAmount" size="mini" :readonly="true" />
              </div>
            </div>
            <div style="margin-left: 50px;">
              <canvas-tooth @canvasImg="canvasToothImg" @ruleFlag="corrective"
              :correctiveImg="correctiveImages" :isCreate="isCreate" v-if="editCanvas||correctiveImages==''"/>
              <img :src="correctiveImages" v-else>
              <br>
              <el-button type="primary" plain @click="editCanvas = !editCanvas" size="mini"
               style="float: right;margin-right: 10%;" v-if="editCanvas==false&&correctiveImages!=''"
              >重新编辑</el-button>
            </div>
            <!-- 备注信息 -->
            <div class="order-input-wrap" style="margin-top: 20px;">
              <base-tag label="其他要求"></base-tag>
              <div class="input-textarea">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 20 }" placeholder="请输入备注信息"
                  v-model="form.orderRemark" />
              </div>
            </div>
            <div class="order-input-wrap" v-if="remarkHistory.length != 0">
              <base-tag label="快捷标签"></base-tag>
              <div class="item-history">
                <el-tag v-for="(item, index) in remarkHistory" :key="index" @click="replaceStr(index)"
                  @close="removeItem(index)" closable style="margin: 5px 5px;">{{ item }}</el-tag>
              </div>
            </div>
            <!-- 第二步结尾 -->
          </div>
        </div>
        <br>
        <!-- 正畸标记牙体 步骤三 -->
        <div class="order-detail-upload" style="min-height: calc(100vh - 413px);" v-if="currentStep === 3">
          <!-- 临床检查 -->
          <div class="order-input-wrap" v-if="subCatalogId == '3010130' && currentStep === 3">
            <base-tag label="临床检查信息与要求（非必填项）"></base-tag>
            <div class="dental-relationship">
              <div class="molar-tooth">
                <div class="molar-Str">
                  磨牙关系
                </div>
                <div class="molar-select">
                  <p class="molar-select-item">
                    <span class="direction">右侧</span>
                    <el-checkbox-group v-model="form.molarRelationShipRight" class="molar-item-check"
                      @change="changeMolar(form.molarRelationShipRight)">
                      <el-checkbox style="margin-right:60px;" label="01">I类</el-checkbox>
                      <el-checkbox style="margin-right:60px;" label="02">II类</el-checkbox>
                      <el-checkbox style="margin-right:60px;" label="03">III类</el-checkbox>
                    </el-checkbox-group>
                  </p>
                  <p class="molar-select-item">
                    <span class="direction">左侧</span>
                    <el-checkbox-group v-model="form.molarRelationShipLeft" class="molar-item-check"
                      @change="changeMolar(form.molarRelationShipLeft)">
                      <el-checkbox style="margin-right:60px;" label="01">I类</el-checkbox>
                      <el-checkbox style="margin-right:60px;" label="02">II类</el-checkbox>
                      <el-checkbox style="margin-right:60px;" label="03">III类</el-checkbox>
                    </el-checkbox-group>
                  </p>
                </div>
              </div>
              <div class="molar-tooth" style="margin-left:5%;">
                <div class="molar-Str">尖牙关系</div>
                <div class="molar-select">
                  <p class="molar-select-item">
                    <span class="direction">右侧</span>
                    <el-checkbox-group v-model="form.canineRelationShipRight" class="molar-item-check"
                      @change="changeMolar(form.canineRelationShipRight)">
                      <el-checkbox style="margin-right:60px;" label="01">中性</el-checkbox>
                      <el-checkbox style="margin-right:60px;" label="02">远中</el-checkbox>
                      <el-checkbox label="03">近中</el-checkbox>
                    </el-checkbox-group>
                  </p>
                  <p class="molar-select-item">
                    <span class="direction">左侧</span>
                    <el-checkbox-group v-model="form.canineRelationShipLeft" class="molar-item-check"
                      @change="changeMolar(form.canineRelationShipLeft)">
                      <el-checkbox style="margin-right:60px;" label="01">中性</el-checkbox>
                      <el-checkbox style="margin-right:60px;" label="02">远中</el-checkbox>
                      <el-checkbox label="03">近中</el-checkbox>
                    </el-checkbox-group>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- 病例分类 -->
          <div class="case-class">
            <div class="case-class-box" style="margin:20px 0 0 2.5%;line-height: 50px;font-size: 15px;">
              <p class="case-class-item" style="float:left;">
                <span style="letter-spacing: 2px;">病例分类</span>
                <el-checkbox-group v-model="form.caseClass" class="molar-item-check" @change="changeCaseClass()"
                  style="margin-left: 50px;">
                  <el-checkbox v-for="(val, key) in caseList" class="item-check" :label="'0'+key" :key="key">{{ val.label}}</el-checkbox>
                </el-checkbox-group>
              </p>
            </div>
          </div>
          <!-- 牙列间隙 -->
          <div style="margin:70px 0 30px 28px">
            <span class="title-Str" style="letter-spacing: 1px;">牙列间隙</span>
            <el-checkbox label="00" v-model="form.interdentalSpace" @change="changeMolar(form.interdentalSpace)"
              style="margin-left: 15px;">全部关闭</el-checkbox>
            <el-checkbox label="01" v-model="form.interdentalSpace"
              @change="changeMolar(form.interdentalSpace)">保留间隙</el-checkbox>
            <input class="input-join" placeholder="输入说明" v-model="form.interdentalSpaceRemark">
            <span class="title-Str">后牙反𬌗</span>
            <el-checkbox label="00" v-model="form.toothRetroversion"
              @change="changeMolar(form.toothRetroversion)">保持</el-checkbox>
            <el-checkbox label="01" v-model="form.toothRetroversion"
              @change="changeMolar(form.toothRetroversion)">纠正</el-checkbox>
          </div>
          <div class="dental-jaw" style="margin-top: 50px;">
            <div class="jaw-Str">中线</div>
            <div class="dental-jaw">
              <div style="line-height:30px;margin-left: 5px;width: 60%;">
                <div style="height:30px;">
                  <span style="margin-right:30px;">上颌</span>
                  <el-checkbox label="00" v-model="form.centerUpper" style="margin-left: 3.7%;"
                    @change="changeMolar(form.centerUpper,'centerUpper')">保持</el-checkbox>
                  <el-checkbox label="01" v-model="form.centerUpper" style="margin-left: 3%;"
                    @change="changeMolar(form.centerUpper)">改善</el-checkbox>
                  <span style="margin-left:30px;">近中(+)</span>
                  <input v-model="form.centerUpperNearMid" @input="filterNonDigits" :readonly="form.centerUpper=='00'"
                    name="centerUpperNearMid" autocomplete="off"
                    style="border-bottom: 1px solid black;background: #F7F7F7;width:75px;text-align: center;">mm
                  <span style="margin-left:30px;">远中(-)</span>
                  <input v-model="form.centerUpperFarAway" @input="filterNonDigits" :readonly="form.centerUpper=='00'"
                    name="centerUpperFarAway" autocomplete="off"
                    style="border-bottom: 1px solid black;background: #F7F7F7;width:75px;text-align: center;">mm
                </div>
                <div style="height:30px;">
                  <span style="margin-right:30px;">下颌</span>
                  <el-checkbox label="00" v-model="form.centerDown" style="margin-left: 3.7%;"
                    @change="changeMolar(form.centerDown,'centerDown')">保持</el-checkbox>
                  <el-checkbox label="01" v-model="form.centerDown" style="margin-left: 3%;"
                    @change="changeMolar(form.centerDown)">改善</el-checkbox>
                  <span style="margin-left:30px;">近中(+)</span>
                  <input v-model="form.centerDownNearMid" @input="filterNonDigits" :readonly="form.centerDown=='00'"
                    name="centerDownNearMid" type="number" autocomplete="off"
                    style="border-bottom: 1px solid black;background: #F7F7F7;width:75px;text-align: center;">mm
                  <span style="margin-left:30px;">远中(-)</span>
                  <input v-model="form.centerDownFarAway" @input="filterNonDigits" :readonly="form.centerDown=='00'"
                    name="centerDownFarAway" autocomplete="off"
                    style="border-bottom: 1px solid black;background: #F7F7F7;width:75px;text-align: center;">mm
                </div>
              </div>
              <!-- 覆𬌗 -->
              <div style="margin-left:5%;line-height:30px;">
                <div>
                  <span class="title-Str">覆𬌗</span>
                  <el-checkbox label="00" v-model="form.coverUp"
                    @change="changeMolar(form.coverUp,'coverUp')">保持</el-checkbox>
                  <el-checkbox label="01" v-model="form.coverUp" @change="changeMolar(form.coverUp)">改善</el-checkbox>
                  <input v-model="form.coverUpParam" @input="filterNonDigits" :readonly="form.coverUp=='00'"
                    name="coverUpParam" autocomplete="off"
                    style="border-bottom: 1px solid black;background: #F7F7F7;width:75px;text-align: center;">mm
                </div>
                <div>
                  <span class="title-Str">覆盖</span>
                  <el-checkbox label="00" v-model="form.cover"
                    @change="changeMolar(form.cover,'cover')">保持</el-checkbox>
                  <el-checkbox label="01" v-model="form.cover" @change="changeMolar(form.cover)">改善</el-checkbox>
                  <input v-model="form.coverParam" @input="filterNonDigits" :readonly="form.cover=='00'"
                    name="coverParam" autocomplete="off"
                    style="border-bottom: 1px solid black;background: #F7F7F7;width:75px;text-align: center;">mm
                </div>
              </div>
            </div>
          </div>


        </div>
        <!-- 步骤四 面相照 口内照 -->
        <div class="order-detail-upload" style="min-height: calc(100vh - 313px);" v-if="currentStep === 4">
          <base-tag label="隐形矫治" :fontSize="25 + 'px'"></base-tag>
          <templateUpload :list="list1" :currentStep="currentStep" :dataType="'22'" @transFile="portraitFile" />
          <templateUpload :list="list2" :currentStep="currentStep" :dataType="'09'" @transFile="portraitFile" />
        </div>
        <!-- 正畸步骤五 影像资料 扫描数据 -->
        <div class="order-detail-upload" style="min-height: calc(100vh - 313px);" v-if="currentStep === 5">
          <base-tag label="隐形矫治" :fontSize="25 + 'px'"></base-tag>
          <boneUploadImg :list="list1" :currentStep="currentStep" :dataType="'23'" @transFile="portraitFile" />
          <modelUpload :list="list2" :currentStep="currentStep" :dataType="'07'" @transFile="portraitFile" />
        </div>
        <!-- 正畸步骤六 CBCT数据 -->
        <div class="order-detail-upload" style="min-height: calc(100vh - 313px);" v-if="currentStep === 6">
          <base-tag label="隐形矫治" :fontSize="25 + 'px'" style="position: relative;"></base-tag><span
            style="position:absolute;left: 9%;top: 15px;color: #409EFF;"> (非必填项)</span>
          <modelUpload :list="list1" :currentStep="currentStep" :dataType="'10'" @transFile="portraitFile" />
        </div>
        <div class="order-ops" v-if="subCatalogId == '3010130'">
          <y-button text="重新创建" classStyle="main-btn ml" @btnClick="clickReSelect" v-if="currentStep === 2"></y-button>
          <y-button text="上一步" classStyle="main-btn ml" @btnClick="clickPreStep"
            v-if="currentStep !== 2 && currentStep != 1"></y-button>
          <y-button text="下一步" :classStyle="subCatalogId == '3010130' ? 'main-btn ml' : 'disabled-btn ml'"
            @btnClick="clickNextStep" v-if="currentStep != 6"></y-button>
          <y-button :text="isEditServOrder == '1' ? '修改提交' : '生成订单'" classStyle="main-btn ml" @btnClick="submitUpdate"
            v-if="currentStep === 6||isEditServOrder=='1'"></y-button>
        </div>
        <Customer class="customerSer"></Customer>
        <el-dialog center title="进度留言" width="30%" :visible.sync="msgDialog" :modal-append-to-body="false"
          :destroy-on-close="true" :lock-scroll="false">
          <el-form label-position="left" :model="ruleForm" ref="ruleForm">
            <el-form-item prop="content" label="留言内容:" label-width="120px">
              <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 8 }" v-model="ruleForm.content"
                placeholder="请填写留言内容内容"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="msgDialog = false">取 消</el-button>
            <el-button type="primary" @click="submitForm">继续制作</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import {
  mapState
} from 'vuex'
// 局部引入
import EleUploadImage from "vue-ele-upload-image";
import YButton from '@/components/YButton';
import BaseTag from '@/components/BaseTag';
import CanvasTooth from '@/components/canvasTooth';
import Customer from '../components/customerSer';
import templateUpload from '../components/templateUpload';
import boneUploadImg from '../components/boneUploadImg';
import modelUpload from '../components/modelUpload';
import {
  getStore
} from '/utils/storage'
import {
  uploadByPieces
} from "../../../../common/upload.js";
import graceChecker, { error } from '../../../../common/graceChecker.js';
export default {
  data() {
    return {
      stepList: [{
        "stepList": ['1'],
        "name": "服务选择",
        "status": -1,
        "icon": "el-icon-thumb"
      },
      {
        "stepList": ['2','3'],
        "name": "设计信息",
        "status": 0,
        "icon": "el-icon-edit"
      },
      {
        "stepList": ['4','5','6'],
        "name": "数据上传",
        "status": 0,
        "icon": "el-icon-upload"
      }
      ],
      colorContact: '',
      colorPhone: '',
      colorPatient: '',
      colorOrderAmount: '',
      subCatalogId: '3010130',
      caseList: [
        { label: '拥挤' },
        { label: '牙列间隙' },
        { label: '前突' },
        { label: '开牙合' },
        { label: '深覆牙合' },
        { label: '深覆盖' },
        { label: '前牙反牙合' },
        { label: '后牙反牙合' },
        { label: '后牙锁牙合' }
      ],
      list1: [],//示例图片信息
      list2: [],//示例图片信息
      isEditServOrder: '0',
      userId: '',
      bannerFlag: false,
      loading: true,
      currentStep: 2,
      nextStep: false,

      currentCatalog: -1,
      currentSubCatalog: -1,
      catalogId: '',
      catalogTitle: '',
      form: {
        /** 发单方诊所/工厂名称 */
        demName: '',
        /** 发单方联系人 */
        demContact: '',
        /** 发单方联系方式 */
        demPhone: '',
        /** 患者名称 */
        demPatient: '',
        // 患者年龄
        demSex: '',
        // 患者年龄
        patientAge: 0,
        molarRelationShipLeft:[],//磨牙左侧
        molarRelationShipRight:[],//磨牙右侧
        canineRelationShipLeft:[],//尖牙左侧
        canineRelationShipRight:[],//尖牙右侧
        caseClass: [],//多选,病例分类
        countCalList: [],//单选计费矫治牙列计费
        centerUpper:[],
        centerUpperNearMid:'',
        centerUpperFarAway:'',
        centerDown:[],
        centerDownNearMid:'',
        centerDownFarAway:'',
        coverUp: [],
        coverUpParam: '',
        cover: [],
        coverParam: '',
        interdentalSpace:[],//牙列间隙
        interdentalSpaceRemark:'',//牙列间隙说明
        toothRetroversion:[],
        /** 是否加急 0=否,1=是 */
        /** 加急费 */
        orderRushFee: 0.00,
        /** 订单总价 */
        orderAmount: 0.00,
        basePrice: 0.00,
        orderRemark: '',
        dataType:'06',
        orderCount:1,
        desLevel:'99'
      },
      /** 扫描数据 */
      dataScan: [],
      /** 设计单照片 */
      dataSheet: [],
      /** 口内照片 */
      dataMouth: [],
      /** CBCT数据 */
      dataCbct: [],
      /** 面像照 */
      dataFaceImg: [],
      /** 影像资料 */
      dataVideo: [],
      // 画布
      correctiveImages:[],
      fileList: [],
      formData: "",
      fileNum: 0,//上传文件数量
      selectFileCount: 0,
      successFileCount: 0,
      remarkHistory: [],//备注历史列表
      isCreate: true,//创建订单的状态还是修改订单的状态，传递给tooth组件
      cateserv: null, // 服务单参数详情
      ruleFlag:false,
      msgDialog:false,//修改订单留言框
      ruleForm:{
        content:''//留言内容
      },
      editCanvas: false,//修改时判断要不要修改画布
    }
  },
  computed: {
    ...mapState(['common', 'user'])
  },
  methods: {
    filterNonDigits(event){
      // 使用正则表达式移除非数字字符
      //填写内容选中改善
      let value = event.target.value.replace(/[^0-9.]/g, '' );
      switch(event.target.name){
        case 'centerUpperNearMid':
          this.form.centerUpperNearMid = value;
          this.form.centerUpper = this.selectedItem(this.form.centerUpperNearMid)
          break;
        case 'centerUpperFarAway':
          this.form.centerUpperFarAway = value;
          this.form.centerUpper = this.selectedItem(this.form.centerUpperFarAway)
          break;
        case 'centerDownNearMid':
          this.form.centerDownNearMid = value;
          this.form.centerDown = this.selectedItem(this.form.centerDownNearMid)
          break;
        case 'centerDownFarAway':
          this.form.centerDownFarAway = value;
          this.form.centerDown = this.selectedItem(this.form.centerDownFarAway)
          break;
        case 'coverUpParam':
          this.form.coverUpParam = value;
          this.form.coverUp = this.selectedItem(this.form.coverUpParam)
          break;
        case 'coverParam':
          this.form.coverParam = value;
          this.form.cover = this.selectedItem(this.form.coverParam)
          break;
      }
    },
    selectedItem(value){
      if(value!=''){
        return ['01']
      }
    },
    // 多选->单选
    changeMolar(list,field) {
      if (list.length > 1) {
        list.shift()
      }
      switch(field){
        case 'centerUpper':
        this.form.centerUpperNearMid = '';
        this.form.centerUpperFarAway = '';
        break;
        case 'centerDown':
        this.form.centerDownNearMid = '';
        this.form.centerDownFarAway = '';
        break;
        case 'coverUp':
        this.form.coverUpParam = '';
        break;
        case 'cover':
        this.form.coverParam = '';
        break;
      }
    },
    changeCaseClass() {
    },
    // 切换步骤对应上传组件的list
    changeStepList() {
      let arr1 = [
        { label: '正面闭口照', imgUrl: '/static/images/orthodontics/img1.png' },
        { label: '正面自然微笑照', imgUrl: '/static/images/orthodontics/img2.png' },
        { label: '右45度闭口面像照', imgUrl: '/static/images/orthodontics/img3.png' },
        { label: '右侧闭口面像照', imgUrl: '/static/images/orthodontics/img4.png' },
      ]
      let arr2 = [
        { label: '上颌牙合向牙弓照', imgUrl: '/static/images/orthodontics/tooth1.png' },
        { label: '右侧45度咬合照', imgUrl: '/static/images/orthodontics/tooth2.png' },
        { label: '正面咬合照', imgUrl: '/static/images/orthodontics/tooth3.png' },
        { label: '左侧45度咬合照', imgUrl: '/static/images/orthodontics/tooth4.png' },
        { label: '下颌牙合向牙弓照', imgUrl: '/static/images/orthodontics/tooth5.png' },
      ]
      let arr3 = [
        { label: '曲面断层片（全景片）', imgUrl: '/static/images/orthodontics/bone1.png' },
        { label: '头颅侧位片', imgUrl: '/static/images/orthodontics/bone2.png' },
      ]
      let arr4 = [
        { label: '', imgUrl: '/static/images/orthodontics/model1.png' },
        { label: '', imgUrl: '/static/images/orthodontics/model2.png' },
        { label: '', imgUrl: '/static/images/orthodontics/model3.png' },
      ]
      let arr5 = [
        { label: '', imgUrl: '/static/images/orthodontics/CBCT1.png' },
        { label: '', imgUrl: '/static/images/orthodontics/CBCT2.png' },
      ]
      if (this.currentStep === 4) {
        this.list1 = arr1
        this.list2 = arr2
      } else if (this.currentStep === 5) {
        this.list1 = arr3
        this.list2 = arr4
      } else if (this.currentStep === 6) {
        this.list1 = arr5
      }
      sessionStorage.setItem('list1', JSON.stringify(this.list1))
      sessionStorage.setItem('list2', JSON.stringify(this.list2))
    },
    // 计算总价
    calAmount() {
      if (this.cateserv == null || this.cateserv.length == 0) {
        this.cateserv = this.common.serv.get(this.subCatalogId)
      }
      // 工厂单价/诊所单价
      if (this.user.demServType == '00') {
        this.form.basePrice = parseFloat(this.cateserv.ftyBprice);
      } else if (this.user.demServType == '10' || this.user.demServType == '11') {
        this.form.basePrice = parseFloat(this.cateserv.clnBprice);
      }
      this.form.orderAmount = parseFloat(Number(this.form.basePrice) + Number(this.form.orderRushFee)).toFixed(2);
    },
    // 控制按钮 - 重新选择
    clickReSelect() {
      this.resetForm();
      this.currentStep = 1;
      this.isCreate = false
      this.nextStep = false
      this.$router.push({
        path: '/order/create',
      })
      this.removeAllSession();
    },
    // 按钮控制 - 下一步
    clickNextStep() {
      if (this.checkValid(this.currentStep) || this.currentStep === 1) {
        if (this.currentStep === 1) {
          this.isCreate = true
          this.form.demContact =  this.user.nickName ;
          this.form.demPhone = this.user.loginName;
          sessionStorage.setItem('cateserv', JSON.stringify(this.cateserv))
        }
        sessionStorage.setItem("isCreate", JSON.stringify(this.isCreate))
        sessionStorage.setItem("subCatalogId", this.subCatalogId)
        this.currentStep += 1;
        sessionStorage.setItem('step', this.currentStep)
      }
      this.changeStepList()
    },
    // 按钮控制 - 上一步
    clickPreStep() {
      this.currentStep -= 1;
      this.changeStepList()
      sessionStorage.setItem('step', this.currentStep)
    },
    // 重置订单下单方信息
    loadOrderParam() {
      this.form.demName = this.user.nickName;
      this.form.demContact = this.user.nickName;
      this.form.demPhone = this.user.mobile;
    },
    // 备注历史记录缓存
    remarkCache() {
      if (!this.remarkHistory.includes(this.form.orderRemark) && this.form.orderRemark != '') {
        this.remarkHistory.push(this.form.orderRemark)
      }
      let tempList = this.remarkHistory.length >= 10 ? [] : this.remarkHistory
      this.remarkHistory.forEach((item, i) => {
        if (this.remarkHistory.length >= 10) {
          if (i <= 9 && i != 0) {
            tempList.push(item)
          }
        }
      })
      this.remarkHistory = tempList
      localStorage.setItem('remarkHistory', JSON.stringify(this.remarkHistory))
    },
    // 判断调用继续制作/提交表单
    submitUpdate(){
      // 根据订单的状态，显示对应的内容提示
      if (this.isEditServOrder == '1' && JSON.parse(sessionStorage.getItem('updateForm')).orderStatus == '60') {
        this.msgDialog = true
      } else {
        this.msgDialog = false
        this.submitForm()
      }
    },
    // 提交表单
    submitForm() {
      let id = this.subCatalogId;
      if (this.checkValid(this.currentStep)) {
        let formData = new FormData();
        for (var key in this.form) {
          formData.append(key, this.form[key]);
        }
        this.formData = formData;
        this.addForm();
        this.remarkCache();
      }
    },
    async uploadFile({ response, file, data }) {
      var loading = this.$loading({
        text: '等待上传完成，已上传 0%'
      });

      uploadByPieces({
        file: file, // 文件
        data: data,
        pieceSize: 3, // 分片大小
        concurrent: 3,
        process: res => {
          loading.setText('等待上传完成，已上传' + res + '%')
          console.log('分片上传 -> process', res)
          // if (res == 100) {
          // loading.close();
          // }
        },
        success: res => {
          var temp = {
            url: res.data.url,
            name: file.name
          }
          if (data.objectType == '07') { //口扫数据
            this.dataScan.push(temp)
          } else if (data.objectType == '08') { //设计单照片
            this.dataSheet.push(temp)
          } else if (data.objectType == '09') { //口内照片
            this.dataMouth.push(temp)
          } else if (data.objectType == '10') { //CBCT数据
            this.dataCbct.push(temp)
            this.fileNum += 1
          } else if (data.objectType == '15') { //扫描杆数据库
            this.dataScanRod.push(temp)
          } else if (data.objectType == '16') {//面相照片
            this.dataFaceImg.push(temp)
          } else if (data.objectType == '17') {//影像资料
            this.dataVideo.push(temp)
          }
          this.successFileCount += 1
          if (this.successFileCount == this.selectFileCount) {
            loading.close();
            this.selectFileCount = 0;
            this.successFileCount = 0;
          }
          // console.log('分片上传 -> success', res)
        },
        error: e => {
          this.selectFileCount = 0
          this.successFileCount = 0
          this.$yxz.msg('网络错误'.e, 'success')
          console.log('分片上传 -> error', e)
        }
      })
    },
    handleChange(file) {
      this.selectFileCount += 1
      return true;
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleRemove(file, fileList, type) {
      let tempdata = ''
      if (type == '07') {
        tempdata = this.dataScan;
      } else if (type == '08') {
        tempdata = this.dataSheet;
      } else if (type == '09') {
        tempdata = this.dataMouth;
      } else if (type == '10') {
        tempdata = this.dataCbct;
      } else if (type == '15') {
        tempdata = this.dataScanRod;
      }
      if (tempdata == '') {
        this.$message("数据错误！！")
        return false
      }
      for (let i = 0; i < tempdata.length; i++) {
        if (file.name === tempdata[i].name) {
          tempdata.splice(i, 1);
        }
      }
      this.$message({
        type: 'success',
        message: '移除成功!'
      });
      this.fileNum -= 1
    },
    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleExceed() {
      this.$message({
        type: 'error',
        message: '最多支持3个文件上传'
      })
    },
    // 上传前处理
    beforeUpload(file) {
      let fileSize = file.size
      const FIVE_M = 10 * 1024 * 1024;
      //大于5M，不允许上传
      if (fileSize > FIVE_M) {
        this.$message.error("最大上传10M")
        return false
      }
      //判断文件类型
      let fileName = file.name
      let reg = /^.+\.(jpeg|png|jpg)$/
      if (!reg.test(fileName)) {
        this.$message.error("只能上传jpeg|png|jpg!")
        return false
      }
      this.selectFileCount += 1
      return true
    },
    ifDefault(obj) {
      if (obj.flag == '' && obj.nearMiddle == ''
        && obj.farAway == '' && obj.coverUpJaw == ''
        && obj.improverData == '') {
        return true;
      }
      return false;
    },
    //传值判断是否操作画布
    corrective(flag) {
      this.ruleFlag = flag
    },
    // 接收画布图片地址
    canvasToothImg(url){
      this.correctiveImages = [];
      this.correctiveImages.push(url);
      this.editCanvas = false;
      sessionStorage.setItem('editCanvas',this.editCanvas);
      sessionStorage.setItem('canvasImage',JSON.stringify(this.correctiveImages));
    },
    isJsonString(str) {
      try {
        const json = JSON.parse(str);
        return true;
      } catch (e) {
        return false;
      }
    },
    toJSON(val){
      if (this.isJsonString(val)) {
        // 如果输入已经是 JSON 字符串，直接返回
        return val;
      } else {
        // 如果输入是数组或对象，转换为 JSON 字符串
        return JSON.stringify(val);
      }
    },
    //添加
    addForm() {
      var tempDataScan = [];
      var tempDataSheet = [];
      var tempDataMouth = [];
      var tempDataCbct = [];
      var tempDataFaceImg = [];
      var tempDataVideo = [];
      var tempCorrectiveImage = [];
      // 上传文件集合

        tempDataScan = this.toJSON(this.dataScan);
        tempDataSheet = this.toJSON(this.dataSheet);
        tempDataMouth = this.toJSON(this.dataMouth);
        tempDataCbct = this.toJSON(this.dataCbct);
        tempDataFaceImg = this.toJSON(this.dataFaceImg);
        tempDataVideo = this.toJSON(this.dataVideo);
        tempCorrectiveImage =this.toJSON(this.correctiveImages);


      let orthodonticsData = {
        patientAge: this.formData.get('patientAge'),
        molarRelationShipLeft: this.formData.get('molarRelationShipLeft') ? this.formData.get('molarRelationShipLeft') : null,
        molarRelationShipRight: this.formData.get('molarRelationShipRight') ? this.formData.get('molarRelationShipRight') : null,
        canineRelationShipLeft: this.formData.get('canineRelationShipLeft') ? this.formData.get('canineRelationShipLeft') : null,
        canineRelationShipRight: this.formData.get('canineRelationShipRight') ? this.formData.get('canineRelationShipRight') : null,
        caseClass: this.formData.get('caseClass'),
        countCalList: this.formData.get('countCalList'),
        centerUpper: this.formData.get('centerUpper') ? this.formData.get('centerUpper') : null,
        centerUpperNearMid: this.formData.get('centerUpperNearMid') ? this.formData.get('centerUpperNearMid') : 0.00,
        centerUpperFarAway: this.formData.get('centerUpperFarAway') ? this.formData.get('centerUpperFarAway') : 0.00,
        centerDown: this.formData.get('centerDown') ? this.formData.get('centerDown') : null,
        centerDownNearMid: this.formData.get('centerDownNearMid') ? this.formData.get('centerDownNearMid') : 0.00,
        centerDownFarAway: this.formData.get('centerDownFarAway') ? this.formData.get('centerDownFarAway') : 0.00,
        coverUp: this.formData.get('coverUp') ? this.formData.get('coverUp') : null,
        coverUpParam: this.formData.get('coverUpParam') ? this.formData.get('coverUpParam') : 0.00,
        cover: this.formData.get('cover') ? this.formData.get('cover') : null,
        coverParam: this.formData.get('coverParam') ? this.formData.get('coverParam') : 0.00,
        interdentalSpace: this.formData.get('interdentalSpace') ? this.formData.get('interdentalSpace') : null,
        interdentalSpaceRemark: this.formData.get('interdentalSpaceRemark') ? this.formData.get('interdentalSpaceRemark') : null,
        toothRetroversion: this.formData.get('toothRetroversion') ? this.formData.get('toothRetroversion') : null,
        basePrice: this.formData.get('basePrice') ? this.formData.get('basePrice') : null,
        // 添加表单字段

        // 画布地址
        correctiveImages:tempCorrectiveImage,
        dataFaceImg:tempDataFaceImg,//面相照
        dataVideo:tempDataVideo,//影响资料
      }

      var orderData = {
        servCataId: this.subCatalogId,
        demName: this.formData.get('demName'),
        demSex: this.formData.get('demSex'),
        demContact: this.formData.get('demContact'),
        demPhone: this.formData.get('demPhone'),
        demPatient: this.formData.get('demPatient'),
        orderCount:this.formData.get('orderCount'),

        orderRushFee: this.formData.get('orderRushFee'),
        orderAmount: this.formData.get('orderAmount'),
        orderRemark: this.formData.get('orderRemark'),
        dataType: this.formData.get('dataType'),
        desLevel:this.formData.get('desLevel'),

        // 添加需要上传文件的队列
        dataScan: tempDataScan,//模型资料
        dataMouth: tempDataMouth,//口内照片
        dataCbct: tempDataCbct,//CBCT资料
      }
      var msg = '您确定生成新订单?'
      if (this.isEditServOrder == '1') {
        let updateForm = ''
        if (sessionStorage.getItem('updateForm')) {
          updateForm = JSON.parse(sessionStorage.getItem('updateForm'))
        }
        orderData.servOrderId = this.$route.query.servOrderId
        orthodonticsData.id = updateForm.orthodonticsData.id
        orderData.orderStatus = updateForm.orderStatus
        orderData.continueDesignMsg = this.ruleForm.content
        sessionStorage.setItem("orderId", orderData.servOrderId)
        msg = '您将完成对服务单的修改,确定继续服务单【' + updateForm.servOrderNo + '】?'
        if(['1010699','1010698'].includes(this.subCatalogId)&&orderData.recessedRetentionAmount==null){
          orderData.recessedRetentionAmount = '0'
        }
      }
      console.log('?',orthodonticsData)
      this.$confirm(msg, '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true
      }).then(() => {
        this.$api.post({
          url: '/biz/orthodontics/dem/add',
          data: {
            bizServOrder: orderData,
            bizOrthodontics: orthodonticsData,
            isEditServOrder: this.isEditServOrder
          }
        }).then(res => {
          if (res.code == 200) {
            let message = this.isEditServOrder=='1'?'修改订单成功':'生成订单成功'
            if(this.isEditServOrder=='1'){
              this.removeAllSession();
            }
            this.$yxz.msg(message, 'success')
            this.$yxz.to('/order/dem');
          } else {
            this.$yxz.msg(res.msg);
          }
        })

      })
    },
    // 控制顶部
    navFixed() {
      if (this.$route.path === '/order/create') {
        var st = document.documentElement.scrollTop || document.body.scrollTop
        st >= 60 ? this.bannerFlag = true : this.bannerFlag = false
      } else {
        return
      }
    },
    checkValid(currentStep) {
      //定义表单规则
      var rule = [{
        name: 'demContact',
        checkType: 'notnull',
        errorMsg: '请输入联系人姓名',
        isValid: '1'
      },
      {
        name: 'demPhone',
        checkType: 'phoneno',
        errorMsg: '请输入11位电话号码',
        isValid: '1'
      },
      {
        name: 'demPatient',
        checkType: "notnull",
        errorMsg: '请输入患者姓名',
        isValid: '1'
      },
      {
        name: 'demSex',
        checkType: "notnull",
        errorMsg: '请选择患者性别',
        isValid: '1'
      },
      {
        name: 'patientAge',
        checkType: "notnull",//应该是非零
        errorMsg: '请选择患者年龄',
        isValid: this.form.patientAge==0?'1':'0'
      },
      {
        name: 'countCalList',
        checkType: "notnull",//应该是非零
        errorMsg: '请选择矫治牙列',
        isValid: this.form.countCalList==''?'1':'0'
      },
      {
        name: 'correctiveImages',
        checkType: "notnull",//应该是非零
        errorMsg: '请保存上传画布图片',
        isValid: this.ruleFlag ? '1':'0'
        // isValid: '0'
      },
      ];

      //isValid字段判断是否需要效验，isValid等于1需要效验，否则不需要效验
      // 填写信息
      var tempRule = rule.filter((item) => {
        return item.isValid == '1'
      })
      //进行表单检查
      var formData = {
        demContact: this.form.demContact,
        demPhone: this.form.demPhone,
        demPatient: this.form.demPatient,
        demSex: this.form.demSex,
        patientAge: this.form.patientAge,
        countCalList: this.form.countCalList,
        correctiveImages: this.correctiveImages,
        dataVideo: this.dataVideo,
        dataFaceImg: this.dataFaceImg,
        dataMouth: this.dataMouth,
        dataScan:this.dataScan,
        dataCbct: this.dataCbct,
      }

      // 表单信息
      var checkRes = graceChecker.check(formData, tempRule);
      if(currentStep == 2){
        if(!checkRes){
          this.$yxz.msg(graceChecker.error);
          return false
        }
        return true
      }else if(currentStep == 3){
        return true
      }else if(currentStep == 4){
        if(this.dataFaceImg.length<2&&this.dataVideo[1]!=''){
          this.$yxz.msg(('请上传至少两张面像照片'),'error')
          return false
        }else if(this.dataMouth.length<5){
          this.$yxz.msg(('请上传五张口内照片'),'error')
          return false
        }
        return true
      }else if(currentStep == 5){
        if(this.dataVideo.length<2&&this.dataVideo[1]!=''){
          this.$yxz.msg(('请上传对应影像资料'),'error')
          return false
        }else if(this.dataScan.length<1){
          this.$yxz.msg(('请上传对应模型资料'),'error')
          return false
        }
        return true
      }else if(currentStep == 6){
        return true
      }
      return false
    },
    // 重置信息
    resetForm() {
      this.currentCatalog = -1;
      this.currentSubCatalog = -1;
      this.form.demPatient = ''
      this.form.basePrice = 0.00;
      this.form.orderRushFee = 0.00;
      this.form.orderAmount = 0.00;
      this.form.orderRemark = '';
      this.form.patientAge = 0;

      this.formData = "";
      this.dataScan = [];
      this.dataSheet = [];
      this.dataMouth = [];
      this.dataCbct = [];
      this.fileList = [];
      this.cateserv = null;
      this.isEditServOrder = '0';
      this.form.dataType = '06';
      this.form.orderCount = 1;
      this.form.desLevel = '99';
    },
    change1() {
      this.colorContact = '#2979ff'
    },
    change2() {
      this.colorPhone = '#2979ff'
    },
    change3() {
      this.colorPatient = '#2979ff'
    },
    // 点击历史替换备注
    replaceStr(index) {
      this.form.orderRemark = this.remarkHistory[index]
    },
    // 移除历史备注项
    removeItem(index) {
      this.remarkHistory.splice(index, 1)
      localStorage.setItem('remarkHistory', JSON.stringify(this.remarkHistory))
    },
    // 面相照/口内照上传传递数据
    portraitFile(data, type) {
      if (type == '22') {//面相照
        this.dataFaceImg = data
      } else if (type == '09') {//口内照
        this.dataMouth = data
      } else if (type == '23') {//影像资料
        this.dataVideo = data
      } else if (type == '07') {//模型数据
        this.dataScan = data
      } else if (type == '10') {//CBCT数据
        this.dataCbct = data
      }
    },
    saveSession(){
      window.addEventListener('beforeunload',()=>{
        sessionStorage.setItem('form',JSON.stringify(this.form));
      })
    },
    // 清除无用session缓存
    removePartSession(){
      sessionStorage.removeItem('isLevel');
      sessionStorage.removeItem('isCreate');
      sessionStorage.removeItem('options1');
      sessionStorage.removeItem('options2');
      sessionStorage.removeItem('options3');
      sessionStorage.removeItem('servBridge');
      sessionStorage.removeItem('montageStr');
      sessionStorage.removeItem('isDevicelistShow');
    },
    // 读取session
    loadSession() {
      this.currentStep = parseInt(this.loadFormSession('step', 2));
      this.list1 = this.loadFormSessionJSON('list1', []);
      this.list2 = this.loadFormSessionJSON('list2', []);
      this.form = this.loadFormSessionJSON('form', this.form);
      this.remarkHistory = localStorage.getItem('remarkHistory') ? JSON.parse(localStorage.getItem('remarkHistory')) : [];
      this.editCanvas = this.loadFormSession('editCanvas', false);
      if (this.isEditServOrder == '0') {
        this.correctiveImages = this.loadFormSessionJSON('canvasImage',this.correctiveImages);
        this.dataFaceImg = this.loadFormSessionJSON('dataFaceList', this.dataFaceImg).map(item => item.url);
        this.dataMouth = this.loadFormSessionJSON('dataMouthList', this.dataMouth).map(item => item.url);
        this.dataVideo = this.loadFormSessionJSON('dataVideoList', this.dataVideo).map(item => item.url);
        this.dataScan = this.loadFormSessionJSON('07', this.dataScan);
        this.dataCbct = this.loadFormSessionJSON('10', this.dataCbct);
        this.editCanvas = true;
      }
    },
    //读取session中加载数据
    loadFormSession(key, defaultValue) {
      const value = sessionStorage.getItem(key);
      return value !== null ? value : defaultValue;
    },
    //从session中加载JSON数据
    loadFormSessionJSON(key, defaultValue) {
      const value = sessionStorage.getItem(key);
      return value !== null && value !== '' && value !== undefined && value !== 'undefined' ? JSON.parse(value) : defaultValue;
    },
    // 移除全部session
    removeAllSession(){
      sessionStorage.clear();
    },
    // 读取详情
    loadingUp(){
      if(sessionStorage.getItem('updateForm')){
        this.catalogTitle = '数字化正畸修复 - 隐形矫治'
        this.isCreate = false
        this.isEditServOrder = '1'
        let detail = this.loadFormSessionJSON('updateForm',{});
        this.forKey(detail.orthodonticsData, this.form)
        this.forKey(detail, this.form)
        this.editCanvas = false;
        this.currentStep = parseInt(this.loadFormSession('step',2));
        this.currentCatalog = -1;
        this.currentSubCatalog = -1;
        this.correctiveImages = detail.orthodonticsData.correctiveImages;
        this.dataFaceImg = detail.orthodonticsData.dataFaceImg;
        this.dataMouth = detail.dataMouth;
        this.dataVideo = detail.orthodonticsData.dataVideo;
        this.dataScan = detail.dataScan;
        this.dataCbct = detail.dataCbct;


        // 直接存session
        sessionStorage.setItem('dataFaceList',this.dataFaceImg);
        sessionStorage.setItem('dataMouthList',this.dataMouth);
        sessionStorage.setItem('dataVideoList',this.dataVideo);
        sessionStorage.setItem('07',this.dataScan);
        sessionStorage.setItem('10',this.dataCbct);
      }
    },
    // 形参合并相同元素给list2，修改订单：订单详情参数合并给form
    forKey(list1, list2) {
      let keyList = ['molarRelationShipLeft', 'molarRelationShipRight',
        'canineRelationShipLeft', 'canineRelationShipRight', 'caseClass',
        'centerUpper', 'coverUp', 'cover', 'centerDown', 'interdentalSpace',
        'toothRetroversion'
      ]
      for (const key1 in list1) {
        for (const key2 in list2) {
          if (key1 === key2) {
            if(keyList.includes(key2)&&(list1[key2]==''||list1[key2]==null||list1[key2]=='0')){
              list1[key2] = [];
            }
            list2[key2] = list1[key2];
          }
        }
      }
    },
  },
  created() {
    this.removePartSession()
    this.loadOrderParam()
    this.loading = false;
    this.catalogTitle = sessionStorage.getItem('catalogTitle')
    this.loadSession()
    this.loadingUp();
  },
  mounted() {
    this.changeStepList();
    this.saveSession()
  },
  components: {
    BaseTag,
    YButton,
    Customer,
    EleUploadImage,
    templateUpload,
    boneUploadImg,
    modelUpload,
    CanvasTooth,
  }
}
</script>
<style lang="scss" scoped>
@import "../../../assets/style/mixin";

.el-input-contact {
  .el-input /deep/ .el-input__inner {
    color: var(--inputColorContact);
  }
}

.el-input-phone {
  .el-input /deep/ .el-input__inner {
    color: var(--inputColorPhone);
  }
}

.el-input-patient {
  .el-input /deep/ .el-input__inner {
    color: var(--inputColorPatient);
  }
}

.el-input-orderamount {
  .el-input /deep/ .el-input__inner {
    color: var(--inputColorOrderAmount);
  }
}

.upload-demp {
  /deep/ .el-upload--picture-card {
    width: 100px;
    height: 100px;
    background-color: #f7f7f7;
  }

  /deep/ .el-upload {
    width: 100px;
    height: 100px;
    line-height: 100px;
  }

  /deep/ .el-upload-list__item {
    width: 100px;
    height: 100px;
  }
}

.order-ops {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  height: 70px;
  background: #f7f7f7;
  border-radius: 0 0 8px 8px;
  border-color: rgba(0, 0, 0, .14);
  box-shadow: rgba(0, 0, 0, .06) 0 1px 7px;
}

.order-detail-design {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 30px;
}

.order-basic-wrap {
  // flex: 1;
  width: 100%;
}

.order-input-wrap {
  // flex: 1;
  width: 100%;
  position: relative;
}

.input-age,
.input-bridge,
.input-hos-cal,
.input-hos-totalPrice,
.input-factory,
.input-not-rush,
.input-with-totalPrice,
.input-form-wrap,
.input-fac-cal-one,
.input-fac-cal-two,
.input-fac-input-with,
.input-fac-cal-totalPrice,
.input-factory-count,
.input-orthodontics,
.input-form-wrap-row,
.input-form-wrap-plate,
.input-form-wrap-craft,
.input-form-precise {
  float: left;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 13px;
}

// 输入框
.input-form-wrap {
  width: 33.33%;
  padding: 3px 10px;
  font-size: 13px;

  /deep/ .input-label {
    text-align: left !important;
    width: 120px;
  }
}

.input-age,
.input-factory,
.input-form-wrap-row,
.input-factory-count,
.input-orthodontics {
  padding: 10px 10px;
  font-size: 13px;
  margin-left: 1%;

  /deep/ .input-label {
    text-align: left !important;
  }
}

.input-form-wrap-row {
  width: 23%;

  /deep/ .input-label {
    width: 120px;
  }
}

.input-factory {
  width: 17.5%;

  // margin-left: 1.4%;
  /deep/ .input-label {
    width: 120px;
  }
}

.input-factory-count {
  width: 17.5%;

  /deep/ .input-label {
    width: 170px;
  }
}

.input-orthodontics {
  width: 19.3%;
  margin-left: 0;

  /deep/ .input-label {
    width: 170px;
  }
}

.input-age {
  width: 18%;
  margin-left: 0;

  /deep/ .input-label {
    width: 100px;
  }
}

.input-form-wrap-plate {
  width: 23%;
  padding: 10px 10px;
  font-size: 13px;
  margin-left: 1.3%;

  /deep/ .input-label {
    width: 120px;
  }
}

.input-fac-cal-two {
  width: 18%;
  margin-left: 20px;

  /deep/ .input-label {
    width: 100px;
  }
}

.input-textarea {
  padding: 5px 10px;
}

.item-history {
  display: flexbox;
  width: 100%;
  padding: 5px 10px;
}

.input-radio,
.input-form {
  width: 186px;
  height: 40px;
  display: flex;
  align-items: center;
}

/deep/ el-option {
  display: block !important;
}

.order-detail-upload {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 0 30px;
}

.input-fac-rush {
  width: 22%;
  margin-left: 1.1%;
  margin-right: -4%;
  float: left;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 10px 0px;
  font-size: 13px;
}

.spacing-height {
  line-height: 60px;
}

/deep/.input-age,
.input-form-wrap,
.input-fac-rush,
.input-orthodontics,
.input-fac-cal-two {
  font-family: "宋体", Arial, sans-serif;
}

//一下为正畸部分css
.dental-relationship {
  display: flex;
  width: 100%;
  height: 90px;
  margin-top: 20px;
  box-sizing: border-box;
  justify-content: center;
}

.molar-tooth {
  display: flex;
  width: 50%;
}

.molar-Str {
  width: 15%;
  height: 100px;
  font-size: 15px;
  line-height: 100px;
  margin-left: 5%;
  color: #00A5D5;
  justify-content: space-between;
  letter-spacing: 2px;
}

.molar-select {
  width: 85%;
  height: 100px;
  margin-top: 16px;
  line-height: 10px;
  justify-content: space-between;
}

.molar-select-item {
  display: flex;
  margin-left: 8%
}

.direction {
  font-size: 16px;
  line-height: 30px;
  justify-content: space-between;
}

.molar-item-check {
  //line-height: 20px;
  justify-content: space-between;
  margin-top: 5px;
  margin-left: 50px;
  /deep/.el-checkbox__label {
    font-size: 16px !important;
  }
}

// hr下面的病例分类
.case-class {
  width: 100%;
  height: 50px;
  display: flex;
  margin-top: 20px;
}

.case-class-box {
  width: 100%;
  height: 40px;
  // font-size: 15px;
  // line-height: 0px;
  margin-left: 5%;
  color: #00A5D5;
  justify-content: space-between;
}

.case-class-item {
  height: 50px;
  display: flex;
  justify-content: space-between;
  .molar-item-check{
    margin-top: 0;
  }

  .item-check {
    justify-content: space-between;
  }
}

.makeCondition::after {
  content: '（可在相应牙位或邻接处进行特殊标注，无特别标注则默认为所有牙齿均可移动、粘接附件和邻面去釉）';
  position: absolute;
  top: 18px;
  left: 80px;
}

// 正畸步骤四 中线
.dental-jaw {
  display: flex;
  box-sizing: border-box;
  width: 100%;
  height: 60px;
  // justify-content: center;
}

.jaw-Str {
  width: 120px;
  font-size: 16px;
  color: #00A5D5;
  line-height: 70px;
  margin-left: 28px;
  justify-content: space-between;
  letter-spacing: 33px;
}

.title-Str {
  font-size: 16px;
  color: #00A5D5;
  margin-right: 30px;
}

// 正畸第四步 输入说明
.input-join {
  width: 350px;
  font-size: 15px;
  margin: 0 55px 0 30px;
  text-align: center;
  background: #F7F7F7;
  border-bottom: 1px solid #00A5D5;
}





.order {
  display: flex;
  flex-direction: column;
  perspective: 3000px;
  position: relative;
  z-index: 19;
  margin: 10px auto;
}

.order-box {
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 19;
  background: #f7f7f7;
  border-radius: 8px;
}

.order-step {
  position: relative;
  overflow: hidden;
  background: #f7f7f7;
  border-radius: 8px 8px 0 0;
  border-color: rgba(0, 0, 0, .14);
  box-shadow: rgba(0, 0, 0, .06) 1px 1px 7px;
  height: 48px;
  line-height: 48px;
  font-size: 15px;
  color: #626262;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  z-index: 10;

  .order-step-wrap {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    i {
      margin-right: 10px;
    }

  }

}

.order-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  height: 58px;
  width: 100%;

  >span {
    // font-size: 18px;
  }
}
.step-active {
  color: rgba(0, 160, 226, 1);
}
</style>
<style lang="scss">
.adv-message {
  background-color: #ffeaa7;
  color: #ffa94d;
  border: 0px;
}
</style>



// WEBPACK FOOTER //
// orthodonticsCreateOrder.vue?6d3a08c3